import { useMutation } from '@tanstack/react-query';
import { postCoupon } from '~/apis/coupon';

type Params = {
  onSuccess?: () => void;
  onError?: (error: { errorCode?: string; reason?: string; valid?: string }) => void;
};
export const usePostCoupon = ({ onSuccess, onError }: Params) => {
  return useMutation({
    mutationFn: (params: Parameters<typeof postCoupon>[0]) => postCoupon(params),
    onSuccess,
    onError,
  });
};
